import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary RoleDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('downloadsDialog.title'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button p-button-danger",
        disabled: _ctx.downloadsList.length == 0,
        onClick: _ctx.deleteAllDownloads
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.deleteAll')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.downloadsList,
        style: {"max-width":"600px"},
        resizableColumns: true,
        columnResizeMode: "fit | expand"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnDefs, (column, index) => {
            return (_openBlock(), _createBlock(_component_Column, {
              key: index,
              field: column.field,
              header: _ctx.$t(column.headerName),
              bodyStyle: column.bodyStyle
            }, _createSlots({ _: 2 }, [
              (column.template)
                ? {
                    name: "body",
                    fn: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-download",
                        class: "p-button-text p-button-rounded p-button-plain",
                        onClick: ($event: any) => (_ctx.downloadContent(slotProps.data))
                      }, null, 8, ["onClick"])
                    ])
                  }
                : {
                    name: "body",
                    fn: _withCtx((slotProps) => [
                      (column.type && column.type == 'date')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(slotProps.data[column.field])), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(slotProps.data[column.field]), 1)
                          ], 64))
                    ])
                  }
            ]), 1032, ["field", "header", "bodyStyle"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}